<div class="main-content currencies-main-content">
	<div class="container-fluid">
		<div class="row">
			<div class="col-md-12">
				<div class="card">
					<div class="card-header card-header-{{color}}-5">
						<h4 class="card-title pointer" (click)="back()"><i class="material-icons">arrow_left</i> Currencies</h4>
						<p class="card-category text-right">Exchange rates and currency maintenance</p>
					</div>
					<div class="card-body">
						<div class="row mb-3">
							<div class="col">
								<button mat-raised-button color="primary" (click)="openAdd(currencyModal)"><i class="material-icons">add</i> Add currency</button>
							</div>
						</div>
						<div class="table-responsive">
							<table mat-table [dataSource]="currencies" matSort class="w-100">
								<ng-container matColumnDef="currabrev">
									<th mat-header-cell *matHeaderCellDef mat-sort-header>Code</th>
									<td mat-cell *matCellDef="let row">
										{{ row.currabrev }}
										<span class="badge badge-default ms-1" *ngIf="row.currabrev === defaultCurrabrev">Default</span>
									</td>
								</ng-container>
								<ng-container matColumnDef="currency">
									<th mat-header-cell *matHeaderCellDef mat-sort-header>Name</th>
									<td mat-cell *matCellDef="let row">{{ row.currency }}</td>
								</ng-container>
								<ng-container matColumnDef="symbol_left">
									<th mat-header-cell *matHeaderCellDef>Symbol left</th>
									<td mat-cell *matCellDef="let row">{{ row.symbol_left || '-' }}</td>
								</ng-container>
								<ng-container matColumnDef="symbol_right">
									<th mat-header-cell *matHeaderCellDef>Symbol right</th>
									<td mat-cell *matCellDef="let row">{{ row.symbol_right || '-' }}</td>
								</ng-container>
								<ng-container matColumnDef="decimalplaces">
									<th mat-header-cell *matHeaderCellDef mat-sort-header>Decimals</th>
									<td mat-cell *matCellDef="let row">{{ row.decimalplaces ?? 2 }}</td>
								</ng-container>
								<ng-container matColumnDef="rate">
									<th mat-header-cell *matHeaderCellDef mat-sort-header>Rate</th>
									<td mat-cell *matCellDef="let row">{{ row.rate }}</td>
								</ng-container>
								<ng-container matColumnDef="status">
									<th mat-header-cell *matHeaderCellDef mat-sort-header>Status</th>
									<td mat-cell *matCellDef="let row">{{ statusLabel(row.status) }}</td>
								</ng-container>
								<ng-container matColumnDef="actions">
									<th mat-header-cell *matHeaderCellDef>Actions</th>
									<td mat-cell *matCellDef="let row">
										<button mat-icon-button (click)="openEdit(currencyModal, row)" matTooltip="Edit"><mat-icon>edit</mat-icon></button>
										<button mat-icon-button *ngIf="row.status == 1 && row.currabrev !== defaultCurrabrev" (click)="deactivate(row)" matTooltip="Deactivate"><mat-icon>toggle_on</mat-icon></button>
										<button mat-icon-button *ngIf="row.status != 1" (click)="activate(row)" matTooltip="Activate"><mat-icon>toggle_off</mat-icon></button>
									</td>
								</ng-container>
								<tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
								<tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
								<tr class="mat-row" *matNoDataRow>
									<td class="mat-cell" [attr.colspan]="displayedColumns.length">No currencies</td>
								</tr>
							</table>
						</div>
						<mat-paginator [pageSizeOptions]="[10, 25, 50]" showFirstLastButtons></mat-paginator>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>

<ng-template #currencyModal let-modal>
	<div class="modal-header">
		<h4 class="modal-title">{{ editing ? 'Edit currency' : 'Add currency' }}</h4>
		<button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()"></button>
	</div>
	<form [formGroup]="form" (ngSubmit)="save()">
		<div class="modal-body text-dark">
			<div class="row">
				<div class="col-md-6 mb-2">
					<mat-form-field appearance="outline" class="w-100">
						<mat-label>Code (currabrev)</mat-label>
						<input matInput formControlName="currabrev" maxlength="3" placeholder="e.g. USD">
						<mat-hint *ngIf="!editing">3 characters max</mat-hint>
					</mat-form-field>
				</div>
				<div class="col-md-6 mb-2">
					<mat-form-field appearance="outline" class="w-100">
						<mat-label>Currency name</mat-label>
						<input matInput formControlName="currency" placeholder="e.g. US Dollar">
					</mat-form-field>
				</div>
				<div class="col-md-6 mb-2">
					<mat-form-field appearance="outline" class="w-100">
						<mat-label>Symbol left</mat-label>
						<input matInput formControlName="symbol_left" placeholder="e.g. $">
					</mat-form-field>
				</div>
				<div class="col-md-6 mb-2">
					<mat-form-field appearance="outline" class="w-100">
						<mat-label>Symbol right</mat-label>
						<input matInput formControlName="symbol_right" placeholder="e.g. €">
					</mat-form-field>
				</div>
				<div class="col-md-6 mb-2">
					<mat-form-field appearance="outline" class="w-100">
						<mat-label>Decimal places</mat-label>
						<input type="number" matInput formControlName="decimalplaces" min="0" max="6">
					</mat-form-field>
				</div>
				<div class="col-md-6 mb-2">
					<mat-form-field appearance="outline" class="w-100">
						<mat-label>Exchange rate</mat-label>
						<input type="number" matInput formControlName="rate" min="0" step="0.0001">
					</mat-form-field>
				</div>
				<div class="col-md-6 mb-2" *ngIf="editing">
					<mat-form-field appearance="outline" class="w-100">
						<mat-label>Status</mat-label>
						<mat-select formControlName="status">
							<mat-option [value]="1">Active</mat-option>
							<mat-option [value]="0">Inactive</mat-option>
						</mat-select>
					</mat-form-field>
				</div>
			</div>
		</div>
		<div class="modal-footer">
			<button mat-button type="button" (click)="modal.dismiss()">Cancel</button>
			<button mat-raised-button color="primary" type="submit" [disabled]="form.invalid">Save</button>
		</div>
	</form>
</ng-template>
